import { render } from "./PreferredDateConfirm.vue?vue&type=template&id=487741b9"
import script from "./PreferredDateConfirm.vue?vue&type=script&lang=js"
export * from "./PreferredDateConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/PreferredDateConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "487741b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('487741b9', __exports__)) {
    api.reload('487741b9', __exports__)
  }
  
  module.hot.accept("./PreferredDateConfirm.vue?vue&type=template&id=487741b9", () => {
    api.rerender('487741b9', render)
  })

}


export default __exports__